/** Shared marketing layout / type scale (rem-based, scales with root font size). */

export const marketingContainerClassName = "mx-auto w-[min(92%,68rem)]";

export const marketingSectionClassName =
  "scroll-mt-20 border-b border-zinc-200 py-10";

export const marketingHeadingClassName =
  "text-[1.4rem] font-[650] leading-tight text-zinc-950";

export const marketingSectionDescriptionClassName =
  "mt-2 max-w-[42ch] text-[0.95rem] leading-[1.55] text-zinc-600";

export const marketingConverterFramingClassName =
  "mt-2 max-w-4xl text-[0.95rem] leading-[1.55] text-zinc-600";

export const marketingProseClassName =
  "mt-4 max-w-3xl space-y-3 text-[0.875rem] leading-[1.55] text-zinc-600";

export const marketingFeatureTitleClassName =
  "text-[0.95rem] font-semibold text-zinc-950";

export const marketingFeatureDescriptionClassName =
  "mt-0.5 text-[0.875rem] leading-normal text-zinc-600";

export const marketingFeatureGridClassName =
  "mt-6 grid gap-x-6 gap-y-5 sm:grid-cols-2";

export const marketingFeatureItemClassName = "flex gap-[0.5em]";

export const marketingFeatureIconClassName =
  "mt-[0.15em] size-[1em] shrink-0 text-brand";

export const marketingStepLabelClassName =
  "text-[0.75rem] font-bold uppercase tracking-[0.04em] text-brand";

export const marketingStepTitleClassName =
  "mt-3 text-[0.95rem] font-semibold text-zinc-950";

export const marketingStepDescriptionClassName =
  "mt-1.5 text-[0.875rem] leading-normal text-zinc-600";

export const marketingStepsClassName =
  "mt-8 grid gap-8 md:grid-cols-3 md:items-start";

export const marketingFormatChipClassName =
  "rounded-md border border-zinc-200 bg-zinc-50 px-3 py-1.5 text-[0.8rem] text-zinc-700";

export const marketingFormatChipOnMutedClassName =
  "rounded-md border border-zinc-200 bg-white px-3 py-1.5 text-[0.8rem] text-zinc-700";

export const marketingUsefulForClassName =
  "mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[0.875rem] text-zinc-700";

export const marketingFaqQuestionClassName =
  "cursor-pointer list-none text-[0.95rem] text-zinc-950 outline-brand marker:content-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 [&::-webkit-details-marker]:hidden";

export const marketingFaqAnswerClassName =
  "mt-2 pr-8 text-[0.875rem] leading-normal text-zinc-600";

export const marketingFaqDescriptionClassName =
  "mt-2 text-[0.875rem] leading-[1.55] text-zinc-600";

export const marketingHeroSectionClassName =
  "border-b border-zinc-200 bg-white pt-10 pb-6 md:pt-14 md:pb-8";

export const marketingHeroTitleClassName =
  "text-[clamp(2rem,2.2vw,2.5rem)] font-bold tracking-tight text-balance text-zinc-950";

export const marketingHeroDescriptionClassName =
  "mt-4 max-w-[56rem] text-[1rem] font-normal leading-[1.55] text-zinc-600";

export const marketingHeroFeaturesClassName =
  "mt-9 flex flex-wrap gap-x-5 gap-y-2 text-[0.875rem] text-zinc-700";

export const marketingRelatedLinkLabelClassName =
  "font-medium text-brand-hover underline-offset-2 hover:underline";

export const marketingRelatedLinkDescriptionClassName =
  "mt-1 block text-[0.875rem] leading-normal text-zinc-600";
